/** Replays the picked tickets of a type through its bulk run, Mocked, so each answers from its recording. */

import { useCallback, useState } from 'react';
import { useAtomValue } from 'jotai';
import { toast } from '@/components/ui/sonner';
import { invalidateQueries } from '@/lib/query-client';
import { getApiErrorMessage } from '@/lib/utils';
import { aiFunctionService } from '@/services/ai-function.service';
import { selectedBusinessUnitIdAtom } from '@/stores/business-unit.store';
import { liveKey } from './use-live-pool';

export const useReplay = (sopId: string, typeId: string) => {
	const buId = useAtomValue(selectedBusinessUnitIdAtom);
	const [starting, setStarting] = useState(false);

	const replay = useCallback(
		async (scenarioIds: string[]): Promise<boolean> => {
			setStarting(true);
			try {
				await aiFunctionService.startBulkRun(sopId, typeId, 'simulated', scenarioIds, buId);
				await invalidateQueries(liveKey(sopId, 'type', typeId));
				return true;
			} catch (err) {
				toast.error(getApiErrorMessage(err, 'Could not start the replay'));
				return false;
			} finally {
				setStarting(false);
			}
		},
		[sopId, typeId, buId]
	);

	return { replay, starting };
};
